'use strict';

var novicell = novicell || {};

novicell.list = novicell.list || new function () {
    this.init = function(data) {
        const listWrappers = document.querySelectorAll('.list-wrapper');
        
        if(!listWrappers) {
            return;
        }
        
        Vue.directive('init', {
            bind: function(el, binding, vnode) {
                // convert kebab-case to camelCase
                let arg = binding.arg.split('-').map((arg, index) => {
                    return (index > 0) ? arg[0].toUpperCase() + arg.substring(1) : arg;
                }).join('');

                vnode.context[arg] = binding.value;
            }
        });

        for (var i = 0; i < listWrappers.length; i++) {
            let currentList = listWrappers[i];

            new Vue({
                el: currentList,
                data: {
                    listItems: [],
                    filteredListItems: [],
                    filters : {}
                },
                mounted: function () {
                    this.filteredListItems = this.listItems;
                },
                methods: {
                    addSelectedFilters: function (filterItem, filterGroup) {
                        var currentGroup = this.filters[filterGroup];

                        if (!currentGroup || !currentGroup.length) {
                            currentGroup = [];
                        }

                        var index = currentGroup.indexOf(filterItem);
                        if (index > -1) {
                            currentGroup.splice(index, 1);
                        } else {
                            currentGroup.push(filterItem);
                        }

                        this.filters[filterGroup] = currentGroup;
                        this.filterItems();
                    },
                    filterItems: function() {
                        var _filteredListItem = this.listItems;
                        for (var k in this.filters) {
                            if (this.filters.hasOwnProperty(k)) {
                                var currentFilter = this.filters[k];

                                if( currentFilter.length ) {
                                    _filteredListItem = _filteredListItem.filter(function(item) {
                                        var selectedGroup = item.FilterGroups.find(function(group) {
                                            return group.Id == k;
                                        });
    
                                        if (selectedGroup) {
                                            return selectedGroup.FilterItems.find(function(filterItem) {
                                                return currentFilter.indexOf(filterItem.Id) > -1;
                                            });
                                        }
                                    });
                                }
                                
                            }
                        }

                        this.filteredListItems = _filteredListItem;
                    },
                    containsObject: function (obj, list) {
                        return list.some(function(item) {
                            return obj.Name === item.Name;
                        });
                    },
                    // Returns comma seperated string with all filters for an item
                    getDataFilters: function (item) {
                        let dataFilterString = '';

                        if(!item.FilterItems || !item.FilterItems.length) {
                            return;
                        }

                        for (let i = 0; i < item.FilterItems.length; i++) {
                            let currentFilter = item.FilterItems[i];
                            dataFilterString = dataFilterString + currentFilter.Id;
                            
                            //Add comma after each filter, exept the last one
                            if(i + 1 != item.FilterItems.length) {
                                dataFilterString += ',';
                            }
                        }
                        return dataFilterString;
                    },
                    getFilterItemsFromGroup: function (groupName) {
                        let filterItems = [];

                        return filterItems;
                    }
                }
            });
        }
    };
}();